import type { SxProps, Theme } from "@mui/material";
import type { useCustomColors } from "../../hooks/useCustomColors";

type Colors = ReturnType<typeof useCustomColors>;

/** The Live Lotto card surface, shared by the signed-in hero and the
 *  signed-out preview so the two can never drift apart. Visual only —
 *  each caller supplies its own padding and inner layout. */
export const heroSurfaceSx = (colors: Colors): SxProps<Theme> => ({
  position: "relative",
  overflow: "hidden",
  borderRadius: "24px",
  border: `1px solid ${colors.border.accent}`,
  background: colors.isDark
    ? `radial-gradient(circle at 84% 48%, rgba(208, 52, 44, 0.52) 0%, transparent 40%), radial-gradient(circle at 8% 100%, ${colors.tint.gold} 0%, transparent 52%), linear-gradient(135deg, ${colors.background.deep} 0%, ${colors.card.background} 52%, rgba(168, 36, 25, 0.82) 100%)`
    : colors.gradient.hero,
  boxShadow: colors.isDark
    ? "0 18px 48px rgba(0, 0, 0, 0.40)"
    : "0 18px 48px rgba(45, 33, 26, 0.12)",
  "&::after": {
    content: '""',
    position: "absolute",
    width: { xs: "220px", md: "360px" },
    height: { xs: "220px", md: "360px" },
    right: { xs: "-72px", md: "20px" },
    bottom: { xs: "-98px", md: "-120px" },
    borderRadius: "50%",
    background: colors.tint.gold,
    filter: "blur(18px)",
    pointerEvents: "none",
  },
});
